<script lang="ts">
  import { router } from './lib/router.svelte'
  import { handleUnauthorisedWith } from './lib/api'
  import AccountLayout from './lib/components/AccountLayout.svelte'
  import AnonymousLayout from './lib/components/AnonymousLayout.svelte'
  import Summary from './routes/Summary.svelte'
  import Billing from './routes/Billing.svelte'
  import Marketing from './routes/Marketing.svelte'
  import Share from './routes/Share.svelte'
  import DeleteAccount from './routes/DeleteAccount.svelte'
  import SignIn from './routes/SignIn.svelte'
  import ForgotPassword from './routes/ForgotPassword.svelte'
  import PasswordReset from './routes/PasswordReset.svelte'
  import EmailPreferences from './routes/EmailPreferences.svelte'

  // A 401 from anywhere lands on sign-in, keeping where they were heading. Wired here rather than in the
  // client so api.ts does not have to import the router, which would import the session, which imports…
  handleUnauthorisedWith(() => router.requireSignIn())

  const route = $derived(router.route)

  // The shells are byte-identical, so the title is the router's to set — nothing here is indexed, and a
  // per-file <title> would be five copies to keep in step for no reader.
  $effect(() => {
    document.title = `${route.title} · Bird Journal`
  })
</script>

{#if route.anonymous}
  <AnonymousLayout title={route.title}>
    {#if route.name === 'sign-in'}
      <SignIn />
    {:else if route.name === 'forgot-password'}
      <ForgotPassword />
    {:else if route.name === 'password-reset'}
      <PasswordReset />
    {:else if route.name === 'email-preferences'}
      <EmailPreferences />
    {/if}
  </AnonymousLayout>
{:else}
  <AccountLayout title={route.title}>
    {#if route.name === 'summary'}
      <Summary />
    {:else if route.name === 'billing'}
      <Billing />
    {:else if route.name === 'marketing'}
      <Marketing />
    {:else if route.name === 'share'}
      <Share />
    {:else if route.name === 'delete'}
      <DeleteAccount />
    {/if}
  </AccountLayout>
{/if}
